import styled, { keyframes } from 'styled-components'

const enterUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Page = styled.main`
  animation: ${enterUp} .3s ease both;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 112px clamp(18px, 4vw, 56px) 56px;

  @media (max-width: 767px) {
    gap: 20px;
    padding: 88px 16px 40px;
  }
`

export const PageHeader = styled.header`
  align-items: flex-end;
  display: flex;
  gap: 24px;
  justify-content: space-between;

  @media (max-width: 767px) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const PageIntro = styled.div`
  max-width: 680px;
`

export const PageEyebrow = styled.div`
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Poppins, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .1em;
  margin-bottom: 8px;
  text-transform: uppercase;
`

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, Poppins, sans-serif;
  font-size: clamp(30px, 3vw, 42px);
  font-weight: 700;
  line-height: 1.08;
  margin: 0 0 10px;
`

export const PageSubtitle = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
`

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;

  .MuiButton-outlinedBlue:not(.Mui-disabled) {
    border-color: ${({ theme }) => theme.palette.colors.subdued};
    color: ${({ theme }) => theme.palette.colors.text};

    &:hover {
      background: ${({ theme }) => theme.palette.colors.badgeMuted};
      border-color: ${({ theme }) => theme.palette.colors.text};
    }
  }

  .MuiButton-root:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.colors.text};
    outline-offset: 3px;
  }

  @media (max-width: 767px) {
    justify-content: space-between;
  }
`

export const Count = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 999px;
  color: ${({ theme }) => theme.palette.colors.muted};
  display: inline-flex;
  font-size: 12px;
  gap: 8px;
  padding: 8px 12px;

  strong {
    color: ${({ theme }) => theme.palette.colors.text};
    font-size: 15px;
  }
`

export const State = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.surfaceElevated};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  padding: 36px 20px;
  text-align: center;
`

export const StateTitle = styled.h2`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 20px;
  margin: 0 0 8px;
`

export const StateText = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  max-width: 520px;
`
